import React from 'react';

const RetailSalesInvoice = ({
    data,
    invoiceData,
    selectedPaymentType = 'Debit',
    selectedInvoiceType = 'TAX INVOICE',
    selectedCopyType = 'Original',
    getImageUrl
}) => {
    const chunkArray = (array, size) => {
        const chunks = [];
        for (let i = 0; i < array.length; i += size) {
            chunks.push(array.slice(i, i + size));
        }
        return chunks;
    };

    const itemChunks = invoiceData.items && invoiceData.items.length > 0
        ? chunkArray(invoiceData.items, 15)
        : [[]];

    const accentColor = '#18181b'; // Zinc-900 high contrast
    const lightBorder = '1.5px solid #e4e4e7';

    return (
        <div className="invoice-pages-container" style={{ display: 'flex', flexDirection: 'column', gap: '20px', fontFamily: '"Segoe UI", "Roboto", "Helvetica", sans-serif', color: '#09090b' }}>
            {itemChunks.map((chunk, pageIndex) => {
                const company = data?.Company || data?.companyId || data?.company || {};

                return (
                    <div className="invoice-box" key={pageIndex} style={{ border: `2px solid ${accentColor}`, color: '#09090b', fontSize: '9px', background: '#fff', width: '800px', margin: '0 auto', boxSizing: 'border-box', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                        {/* Compact Header */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: `2px solid ${accentColor}`, paddingBottom: '10px' }}>
                            <div style={{ flex: 1 }}>
                                <div className="header-image-container">
                                    <h1 style={{ margin: 0, fontSize: '20px', fontWeight: '900', color: accentColor, textTransform: 'uppercase' }}>{data?.invoiceCompanyName || data?.invoice_company_name || data?.companyName || 'COMPANY NAME'}</h1>
                                    <p style={{ margin: '2px 0 0', fontWeight: '600' }}>{data?.invoiceCompanyAddress || data?.invoice_company_address || data?.companyAddress || ''}</p>
                                    <p style={{ margin: '2px 0 0' }}>GSTIN: {company?.company_gst_number || company?.companyGstNumber || ''} | PAN: {company?.company_pan_card_number || ''}</p>
                                </div>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <div style={{ background: accentColor, color: '#fff', padding: '4px 10px', fontWeight: 'bold', fontSize: '12px', display: 'inline-block', textTransform: 'uppercase' }}>{selectedInvoiceType}</div>
                                <div style={{ marginTop: '5px', fontSize: '9px', fontWeight: 'bold' }}>{selectedCopyType} Copy | Payment: {selectedPaymentType}</div>
                            </div>
                        </div>

                        {/* Addresses side-by-side */}
                        <div style={{ display: 'flex', borderBottom: lightBorder, margin: '8px 0 0', paddingBottom: '8px' }}>
                            <div style={{ flex: 1, paddingRight: '10px', borderRight: lightBorder }}>
                                <div style={{ fontWeight: 'bold', textDecoration: 'underline', marginBottom: '4px', textTransform: 'uppercase' }}>Customer Details:</div>
                                <div style={{ fontWeight: 'bold', fontSize: '10px' }}>{invoiceData.buyer.name}</div>
                                <div>{invoiceData.buyer.address} {invoiceData.buyer.cityState}</div>
                                <div>GSTIN: <strong>{invoiceData.buyer.gstin}</strong> | PAN: {invoiceData.buyer.pan}</div>
                                <div>POS: {invoiceData.buyer.placeOfSupply} (Code: {invoiceData.buyer.stateCode})</div>
                            </div>
                            <div style={{ flex: 1, paddingLeft: '10px' }}>
                                <div style={{ fontWeight: 'bold', textDecoration: 'underline', marginBottom: '4px', textTransform: 'uppercase' }}>Shipping Details:</div>
                                <div style={{ fontWeight: 'bold', fontSize: '10px' }}>{invoiceData.consignee.name}</div>
                                <div>{invoiceData.consignee.address} {invoiceData.consignee.cityState}</div>
                                <div>GSTIN: <strong>{invoiceData.consignee.gstin}</strong></div>
                            </div>
                        </div>

                        {/* Invoice Metadata */}
                        <table style={{ width: '100%', borderCollapse: 'collapse', borderBottom: `2px solid ${accentColor}`, margin: '8px 0', fontSize: '9px' }}>
                            <tbody>
                                <tr style={{ borderBottom: lightBorder }}>
                                    <td style={{ padding: '4px 0' }}><strong>{data?.isChallan ? 'CHALLAN NO' : 'INVOICE NO'}:</strong> {invoiceData.invoiceNo}</td>
                                    <td style={{ padding: '4px 0' }}><strong>DATE:</strong> {invoiceData.invoiceDate}</td>
                                    <td style={{ padding: '4px 0' }}><strong>VEHICLE NO:</strong> {invoiceData.vehicleNo || 'N/A'}</td>
                                    <td style={{ padding: '4px 0' }}><strong>TRANSPORTER:</strong> {invoiceData.transporter}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '4px 0' }}><strong>LR NO:</strong> {invoiceData.lrNo || 'N/A'} {invoiceData.lrDate ? `| DT: ${invoiceData.lrDate}` : ''}</td>
                                    <td style={{ padding: '4px 0' }}><strong>CONTAINER NO:</strong> {invoiceData.containerNo || 'N/A'}</td>
                                    <td style={{ padding: '4px 0' }}><strong>SEAL NO:</strong> {invoiceData.sealNo || 'N/A'}</td>
                                    <td style={{ padding: '4px 0' }}><strong>E-WAY BILL:</strong> {invoiceData.eWayBillNo || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Products Header */}
                        <div style={{ display: 'grid', gridTemplateColumns: '30px 1fr 80px 60px 60px 40px 60px 80px', borderBottom: `2px solid ${accentColor}`, fontWeight: 'bold', paddingBottom: '4px', textTransform: 'uppercase' }}>
                            <div>SR</div>
                            <div>ITEMS DESCRIPTION</div>
                            <div style={{ textAlign: 'center' }}>SIZE</div>
                            <div style={{ textAlign: 'center' }}>HSN</div>
                            <div style={{ textAlign: 'center' }}>GRADE</div>
                            <div style={{ textAlign: 'center' }}>QTY</div>
                            <div style={{ textAlign: 'right' }}>RATE</div>
                            <div style={{ textAlign: 'right' }}>AMOUNT</div>
                        </div>

                        {/* Items Content */}
                        <div className="invoice-content-container" style={{ display: 'flex', flexDirection: 'column', minHeight: '380px' }}>
                            {chunk.map((item, i) => (
                                <div key={i} style={{ display: 'grid', gridTemplateColumns: '30px 1fr 80px 60px 60px 40px 60px 80px', padding: '6px 0', borderBottom: lightBorder, alignItems: 'center' }}>
                                    <div>{item.srNo}</div>
                                    <div style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                                        {item.product}
                                        {item.category && <span style={{ fontWeight: 'normal', fontSize: '8px', color: '#555', display: 'block' }}>({item.category} {item.color ? `| ${item.color}` : ''})</span>}
                                    </div>
                                    <div style={{ textAlign: 'center', textTransform: 'uppercase' }}>{item.model}</div>
                                    <div style={{ textAlign: 'center' }}>{item.hsn}</div>
                                    <div style={{ textAlign: 'center', textTransform: 'uppercase' }}>{item.grade}</div>
                                    <div style={{ textAlign: 'center', fontWeight: 'bold' }}>{item.qty} <span style={{ fontSize: '8px', fontWeight: 'normal' }}>{item.unit || ''}</span></div>
                                    <div style={{ textAlign: 'right' }}>{item.rate}</div>
                                    <div style={{ textAlign: 'right', fontWeight: 'bold' }}>{item.amount}</div>
                                </div>
                            ))}
                            <div style={{ flex: 1 }}></div>
                        </div>

                        {/* Totals Section */}
                        <div style={{ display: 'grid', gridTemplateColumns: '30px 1fr 80px 60px 60px 40px 60px 80px', borderTop: `2px solid ${accentColor}`, borderBottom: `2px solid ${accentColor}`, fontWeight: 'bold', padding: '6px 0' }}>
                            <div style={{ gridColumn: '1 / span 5' }}>TOTAL QTY & SUB TOTAL:</div>
                            <div style={{ textAlign: 'center' }}>{invoiceData.totals.qty}</div>
                            <div></div>
                            <div style={{ textAlign: 'right' }}>{invoiceData.totals.subTotal}</div>
                        </div>

                        {/* Bottom Summary Grid */}
                        <div style={{ display: 'flex', marginTop: '10px', gap: '20px' }}>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '4px' }}>Bank Details:</div>
                                <div style={{ fontSize: '9px', lineHeight: '1.4' }}>
                                    Bank Name: <strong>{invoiceData.bank.name}</strong><br />
                                    Account Name: <strong>{invoiceData.bank.accountName}</strong><br />
                                    Account No: <strong>{invoiceData.bank.accountNumber}</strong><br />
                                    IFSC Code: <strong>{invoiceData.bank.ifsc}</strong><br />
                                    IEC No / PAN No: {company?.companySwiftCode || 'N/A'} / {company?.company_pan_card_number || 'N/A'}
                                </div>

                                <div style={{ marginTop: '8px', borderTop: '1px dashed #ccc', paddingTop: '4px' }}>
                                    <strong>REMARK:</strong> {data?.remark || 'N/A'}
                                </div>
                                <div style={{ marginTop: '4px', textTransform: 'uppercase' }}>
                                    <strong>PAYMENT TERMS:</strong> {invoiceData.paymentTerms || data?.paymentTerms || selectedPaymentType || 'N/A'}
                                </div>
                            </div>

                            <div style={{ width: '250px' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '9px' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '2px 0' }}>SUB TOTAL</td>
                                            <td style={{ padding: '2px 0', textAlign: 'right' }}>{invoiceData.totals.subTotal}</td>
                                        </tr>
                                        {parseFloat(invoiceData.totals.discount) > 0 && (
                                            <tr>
                                                <td style={{ padding: '2px 0', color: '#b91c1c' }}>DISCOUNT ({invoiceData.totals.discountPercent}{invoiceData.totals.discountType})</td>
                                                <td style={{ padding: '2px 0', textAlign: 'right', color: '#b91c1c' }}>-{invoiceData.totals.discount}</td>
                                            </tr>
                                        )}
                                        {parseFloat(invoiceData.totals.insurance) > 0 && (
                                            <tr>
                                                <td style={{ padding: '2px 0' }}>INSURANCE ({invoiceData.totals.insurancePercent}%)</td>
                                                <td style={{ padding: '2px 0', textAlign: 'right' }}>{invoiceData.totals.insurance}</td>
                                            </tr>
                                        )}
                                        {parseFloat(invoiceData.totals.extra) > 0 && (
                                            <tr>
                                                <td style={{ padding: '2px 0', textTransform: 'uppercase' }}>{invoiceData.extraChargesName || data?.extraChargesName || 'EXTRA CHARGES'}</td>
                                                <td style={{ padding: '2px 0', textAlign: 'right' }}>{invoiceData.totals.extra}</td>
                                            </tr>
                                        )}
                                        <tr style={{ borderTop: lightBorder, borderBottom: lightBorder, fontWeight: 'bold' }}>
                                            <td style={{ padding: '4px 0' }}>TAXABLE AMOUNT</td>
                                            <td style={{ padding: '4px 0', textAlign: 'right' }}>{invoiceData.totals.taxableAmount}</td>
                                        </tr>
                                        {invoiceData.totals.isLocal ? (
                                            <>
                                                <tr>
                                                    <td style={{ padding: '2px 0' }}>CGST ({invoiceData.totals.tax1Rate}%)</td>
                                                    <td style={{ padding: '2px 0', textAlign: 'right' }}>{invoiceData.totals.tax1}</td>
                                                </tr>
                                                <tr style={{ borderBottom: lightBorder }}>
                                                    <td style={{ padding: '2px 0' }}>SGST ({invoiceData.totals.tax2Rate}%)</td>
                                                    <td style={{ padding: '2px 0', textAlign: 'right' }}>{invoiceData.totals.tax2}</td>
                                                </tr>
                                            </>
                                        ) : (
                                            <tr style={{ borderBottom: lightBorder }}>
                                                <td style={{ padding: '2px 0' }}>IGST ({invoiceData.totals.tax1Rate + invoiceData.totals.tax2Rate}%)</td>
                                                <td style={{ padding: '2px 0', textAlign: 'right' }}>{invoiceData.totals.totalTax}</td>
                                            </tr>
                                        )}
                                        <tr style={{ fontSize: '11px', fontWeight: 'bold', color: accentColor }}>
                                            <td style={{ padding: '6px 0' }}>GRAND TOTAL</td>
                                            <td style={{ padding: '6px 0', textAlign: 'right' }}>₹{invoiceData.totals.grandTotal}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Words */}
                        <div style={{ background: '#f4f4f5', padding: '6px', marginTop: '6px', fontSize: '9px' }}>
                            <strong>RUPEES IN WORDS:</strong> {invoiceData.totals.words.toUpperCase()}
                        </div>

                        {/* Signatures */}
                        <div style={{ display: 'flex', borderTop: `2px solid ${accentColor}`, marginTop: 'auto', paddingTop: '10px' }}>
                            <div style={{ flex: 1, fontSize: '8px', paddingRight: '15px' }}>
                                <strong>TERMS & CONDITIONS:</strong><br />
                                {data?.termsCondtion || data?.terms_condtion || '1. Goods once sold will not be taken back.\n2. Subject to jurisdiction.'}
                            </div>
                            <div style={{ width: '220px', textAlign: 'center' }}>
                                <div style={{ fontWeight: 'bold' }}>FOR, {company?.company_name || data?.companyName || 'ASENSIA INDUSTRY'}</div>
                                <div className="auth-sign-img" style={{ height: '35px', margin: '5px 0' }}>
                                    {(() => {
                                        const sigImg = company?.company_digital_signature || company?.companyDigitalSignature;
                                        if (sigImg) {
                                            return (
                                                <img
                                                    src={getImageUrl(sigImg)}
                                                    alt="Authorized Signatory"
                                                    crossOrigin="anonymous"
                                                    style={{ maxHeight: '30px', maxWidth: '100%', objectFit: 'contain' }}
                                                />
                                            );
                                        }
                                        return null;
                                    })()}
                                </div>
                                <strong style={{ fontSize: '8px' }}>(AUTHORISED SIGNATORY)</strong>
                            </div>
                        </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default RetailSalesInvoice;
